import { render, staticRenderFns } from "./AlertContainer.vue?vue&type=template&id=9d9f5f64"
import script from "./AlertContainer.vue?vue&type=script&lang=js"
export * from "./AlertContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports